import { useMemo } from 'react';

import { useActions } from '../../hooks/useActions';
import { useUser } from '../../hooks/useUser';

export const useAuthForm = () => {
  const { register, setFormType, setPhoneOrEmail } = useActions();
  const { phone_or_email } = useUser();
  const onRegisterEmail = (data_phone_or_email: string) => {
    register({
      phone_or_email: data_phone_or_email,
      action: 'send_user_temp_pwd',
    });
    setPhoneOrEmail(data_phone_or_email);
    localStorage.setItem("pe", data_phone_or_email);
  };

  const onRegisterPhone = (data_phone_or_email: string) => {
    register({
      phone_or_email: data_phone_or_email,
      action: 'register_user_with_temp_pwd',
    });
    setPhoneOrEmail(data_phone_or_email);
    localStorage.setItem("pe", data_phone_or_email);
    setFormType('code');
  };
  return useMemo(
    () => ({
      onRegisterEmail,
      onRegisterPhone,
      phone_or_email,
    }),
    [phone_or_email]
  );
};
